const StatusForm = ({ status }) => {
   const attente = "draft";
   const payer = "paid";
   //TODO: Add the last status
   const refus = "???";

   const getColor = (status) => {
      switch (status) {
         case attente:
            return "orange";
         case payer:
            return "#58D2C3";
         case refus:
            return "red";
         default:
            return "gray";
      }
   };

   const getText = (status) => {
      switch (status) {
         case attente:
            return "A venir";
         case payer:
            return "Payée";
         case refus:
            return "Refus";
         default:
            return "Non défini";
      }
   };

   const circleStyle = {
      width: "12px",
      height: "12px",
      borderRadius: "50%",
      backgroundColor: getColor(status),
      display: "inline-block",
   };

   return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "4px" }}>
         <span style={circleStyle}></span>
         <p style={{ margin: 0 }}>{getText(status)}</p>
      </div>
   );
};

export default StatusForm;
